// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// --- RxJs
import { Observable, combineLatest, forkJoin, map, of, switchMap, take } from 'rxjs';

// --- HS Code
import { OidcService } from '../services';

// #endregion

export const respondentGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const oidcService: OidcService = inject(OidcService);
  const router: Router = inject(Router);

  return combineLatest([oidcService.isRespondent$, oidcService.isParticipant$]).pipe(
    map(([isRespondent, isParticipant]) => {
      if (isRespondent) {
        console.log('isRespondent: True');
        return true;
      } else if (isParticipant) {
        console.log('isParticipant: True');
        return router.createUrlTree(['/dashboard']);
      } else {
        console.log('Going home');
        return router.createUrlTree(['/']);
      }
    })
  );
}
